import { useAtomValue } from 'jotai';
import * as React from 'react';
import { FullScreenSpinner, isNonMobileWeb, YStack } from 'smoothie';

import FullScreenError from '../../common/components/FullScreenError';
import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import BookSessionPrompt from '../../guidanceSessions/components/BookSessionPrompt';
import { GuidanceSessionType } from '../../guidanceSessions/types/GuidanceSessions';
import LogRocketFacade from '../../logger/log-rocket/LogRocketFacade';
import { captureException } from '../../logger/Logger';
import useGuideMessaging from '../hooks/useGuideMessaging';
import useSendbird from '../hooks/useSendbird';
import { guideMessagingSearchItemAtom } from '../state/MessagingAtoms';
import Chat from './Chat';

const GuideMessaging = () => {
    LogRocketFacade.tagPage('GuideMessaging');
    const user = useAuthedUser();
    const guide = user.membership?.guide;
    const { isLoading: isLoadingGuideMessaging, guideMessaging } =
        useGuideMessaging();
    const { sdk: sendbirdSdk, isLoading: isLoadingSendbird } = useSendbird();
    const guideMessagingSearchItem = useAtomValue(guideMessagingSearchItemAtom);

    if (guide == null) {
        return (
            <YStack
                height="100%"
                width="100%"
                paddingHorizontal={60}
                justifyContent="center"
                alignItems="center"
            >
                <BookSessionPrompt
                    sessionType={GuidanceSessionType.DISCOVERY}
                />
            </YStack>
        );
    }

    const isLoading = isLoadingGuideMessaging || isLoadingSendbird;
    if (isLoading) {
        return <FullScreenSpinner />;
    }

    if (!guideMessaging || sendbirdSdk == null) {
        if (!guideMessaging) {
            captureException(new Error(`Failed to load Guide Messaging.`));
        }
        return <FullScreenError hasBackButton={!isNonMobileWeb} />;
    }

    return (
        <Chat
            guideMessaging={guideMessaging}
            searchItem={guideMessagingSearchItem}
        />
    );
};

export default GuideMessaging;
